import styled from 'styled-components';

export const Lineup = styled.div`
  width: 100%;
`;

export const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin-top: 8px;
  background-color: #fff;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  height: 53px;
  border-bottom: 1px solid #f2f2f2;
  h2 {
    margin-left: 15px;
    font-size: 14px;
    color: #151515;
  }
`;

export const Table = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const EmptyLineup = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 0px;
  h3 {
    margin-top: 23px;
    color: #757575;
  }
`;

export const Tab = styled.div`
  box-sizing: border-box;
  display: flex;
  // height: 74px;
  width: 100%;
  margin-top: 8px;
  padding: 20px 15px;
  background-color: #ffffff;
`;

export const Button = styled.button`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 34px;
  border: solid 1px #78818e;
  background-color: #ffffff;
  font-size: 13px;
  &.active {
    background-color: #78818e;
    color: #ffffff;
  }
`;
